"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
var react_1 = __importDefault(require("react"));
var style_scss_1 = __importDefault(require("./style.scss"));
var Overlay = function (_a) {
    var onClick = _a.onClick, onContextMenu = _a.onContextMenu;
    return (react_1.default.createElement("div", { onContextMenu: function (e) {
            e.preventDefault();
            e.persist();
            if (!onContextMenu) {
                onClick(e);
                return;
            }
            onContextMenu(e);
        }, className: style_scss_1.default.overlay, onClick: onClick }));
};
exports.default = Overlay;
